export enum StorageKey {
  TIMEZONE = 'TIMEZONE',
  LANGUAGE = 'LANGUAGE',
  LAST_ON_ERROR_AUTO_RELOADED_AT = 'last_on_error_auto_reloaded_at',
}
